import { animate, diagramAnimationDuration } from '../utils/animation'

export const animateIfVisible = (bars, diagramType, maximumBarLength, maxValue, highlight, highlightValue, decimals, locale) => {
  bars.forEach((bar) => {
    const itemJSON = JSON.parse(bar.dataset.item)
    saveTransitionSettings(bar)
    bar.style.flex = 1
    if (diagramType == 'horizontal') {
      bar.style.maxWidth = (maximumBarLength / maxValue) * parseFloat(itemJSON.value) + 'px'
    } else {
      bar.style.maxHeight = (maximumBarLength / maxValue) * parseFloat(itemJSON.value) + 'px'
    }
  })
  if (highlight) {
    animate(highlight, diagramAnimationDuration, highlightValue, decimals, locale)
  }
}

export const handleIfCompletelyHidden = (highlight, bars, diagramType) => {
  if (highlight) {
    highlight.innerText = 0
  }
  bars.forEach((bar) => {
    restoreTransitionSettings(bar)
    if (diagramType == 'horizontal') {
      bar.style.maxWidth = '0px'
    } else {
      bar.style.maxHeight = '0px'
    }
    bar.style.flex = 0
  })
}

const saveTransitionSettings = (bar) => {
  bar.style.transitionDelay = bar.dataset.delay
  bar.style.transitionDuration = bar.dataset.duration
}

const restoreTransitionSettings = (bar) => {
  bar.dataset.delay = bar.style.transitionDelay
  bar.dataset.duration = bar.style.transitionDuration
  bar.style.transitionDelay = '0s'
  bar.style.transitionDuration = '0s'
}
